import React, { useState } from "react";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
import { useNavigate, Link } from "react-router-dom";
import { TfiEye } from "react-icons/tfi";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
// import { AuthContext } from "../../contexts/AuthContext";
import { startRegister } from "../../actions/auth";

export const Registrarse = () => {
  // const { registrar } = React.useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    apellidos: "",
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
    // documentType: "",
    // documentNumber: "",
    // phone: "",
  })

  const [error, setError] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Manejar cambios en inputs
  const handleChange = (e) => {
    const { name, value } = e.target;

    // if (name === "documentNumber") {
    //   if (form.documentType === "dni") {
    //     const onlyNumbers = value.replace(/\D/g, "").slice(0, 8);
    //     setForm((prev) => ({ ...prev, [name]: onlyNumbers }));
    //   }
    //   else if (form.documentType === "pasaporte") {
    //     const alphanumeric = value.replace(/[^A-Za-z0-9]/g, "").slice(0, 9);
    //     setForm((prev) => ({ ...prev, [name]: alphanumeric }));
    //   }
    //   return;
    // }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Limpiar error cuando el usuario escribe
    setError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Manejar cambio del PhoneInput
  {/* <  const handlePhoneChange = (value) => {
    setForm((prev) => ({
      ...prev,
      phone: value,
    }));
    setError((prev) => ({
      ...prev,
      phone: "",
    }));
  };> */}

  // Validar formulario
  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "El nombre es obligatorio";

    if (!form.apellidos.trim()) newErrors.apellidos = "Los apellidos son obligatorios";

    if (!form.email.trim()) newErrors.email = "El correo es obligatorio";
    else if (!/\S+@\S+\.\S+/.test(form.email))
      newErrors.email = "El correo no es válido";

    if (!form.confirmEmail.trim())
      newErrors.confirmEmail = "Confirme su correo electrónico";
    else if (form.email !== form.confirmEmail)
      newErrors.confirmEmail = "Los correos no coinciden";

    if (!form.password) {
      newErrors.password = "La contraseña es obligatoria";
    } else if (form.password.length < 8) {
      newErrors.password = "La contraseña debe tener al menos 8 caracteres";
    }

    if (!form.confirmPassword)
      newErrors.confirmPassword = "Confirme su contraseña";
    else if (form.password !== form.confirmPassword)
      newErrors.confirmPassword = "Las contraseñas no coinciden";

    // if (!form.documentType)
    //   newErrors.documentType = "Seleccione un tipo de documento";

    // if (!form.documentNumber.trim())
    //   newErrors.documentNumber = "El documento es obligatorio";
    // else if (form.documentType === "dni") {
    //   if (form.documentNumber.length !== 8)
    //     newErrors.documentNumber = "El DNI debe tener exactamente 8 dígitos";
    // } else if (form.documentType === "pasaporte") {
    //   if (form.documentNumber.length < 6 || form.documentNumber.length > 9)
    //     newErrors.documentNumber = "El pasaporte debe tener entre 6 y 9 caracteres";
    // }

    // if (!form.phone || form.phone.length < 10)
    //   newErrors.phone = "El teléfono es obligatorio y debe ser válido";

    return newErrors;
  };

  // Mostrar los campos vacíos con error en Swal
  const handleCrearCuenta = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      Swal.fire({
        icon: "error",
        title: "Falta completar el formulario, revise por favor",
        showConfirmButton: false,
        timer: 2500,
        customClass: {
          container: 'custom-body'
        }
      });

      return;
    }

    // Solo enviar los campos necesarios
    // const payload = {
    //   usuarioNombres: form.name,
    //   usuarioApellidos: form.apellidos,
    //   usuarioEmail: form.email,
    //   usuarioPassword: form.password,
    // };
    const result = await dispatch(startRegister({
      usuarioNombres: form.name,
      usuarioApellidos: form.apellidos,
      usuarioEmail: form.email,
      usuarioPassword: form.password,
    }));

    if (result?.ok) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Verifique su correo electrónico",
        text: "Le hemos enviado un código de verificación. Revise su bandeja de entrada.",
        timer: 2500,
        showConfirmButton: false,
        timerProgressBar: true,
        customClass: {
          container: 'custom-body'
        }
      }).then(() => {
        navigate("/email-verificacion", {
          state: { email: form.email },
        });
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Algo salió mal",
        text: result?.msg || "Intente nuevamente",
        timer: 2500,
        showConfirmButton: false,
        customClass: {
          container: 'custom-body'
        }
      });
    }
  };


  return (
    <div className="register-container font-family-montserrat">
      <form className="register-form container-100 txt-start">
        <h2> REGISTRARSE</h2>
        <div className="form-grid">

          <div className="form-group-register">
            <label htmlFor="name">Nombre *</label>
            {/* <input type="text" id="name" name="name" className="form-input" /> */}
            <input
              type="text"
              id="name"
              name="name"
              className={`form-input ${error.name ? "input-error" : ""}`}
              value={form.name}
              onChange={handleChange}
            />
            {error.name && <p className="error-text">{error.name}</p>}
          </div>

          <div className="form-group-register">
            <label htmlFor="apellidos">Apellidos *</label>
            {/* <input type="text" id="name" name="name" className="form-input" /> */}
            <input
              type="text"
              id="apellidos"
              name="apellidos"
              className={`form-input ${error.apellidos ? "input-error" : ""}`}
              value={form.apellidos}
              onChange={handleChange}
            />
            {error.apellidos && <p className="error-text">{error.apellidos}</p>}
          </div>

          <div className="form-group-register">
            <label htmlFor="email" className="txt-start">
              Correo electrónico *
            </label>
            {/* <input type="email" id="email" className="form-input" /> */}
            <input
              type="email"
              id="email"
              name="email"
              className={`form-input ${error.email ? "input-error" : ""}`}
              value={form.email}
              onChange={handleChange}
            />
            {error.email && <p className="error-text">{error.email}</p>}
          </div>

          <div className="form-group-register">
            <label htmlFor="email" className="txt-start">
              Confirmar correo electrónico *
            </label>
            {/* <input type="email" id="email" className="form-input" /> */}
            <input
              type="email"
              id="confirmEmail"
              name="confirmEmail"
              className={`form-input ${error.confirmEmail ? "input-error" : ""}`}
              value={form.confirmEmail}
              onChange={handleChange}
            />
            {error.confirmEmail && <p className="error-text">{error.confirmEmail}</p>}
          </div>

          <div className="form-group-register password">
            <label htmlFor="password" className="txt-start">
              Contraseña *
            </label>
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                className={`form-input ${error.password ? "input-error" : ""}`}
                value={form.password}
                onChange={handleChange}
                required
              />
              <span
                className="eyes-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                <TfiEye size={29} style={{ color: "C1C1C1" }} />
              </span>
            </div>
            {error.password && <p className="error-text">{error.password}</p>}
          </div>

          <div className="form-group-register password">
            <label htmlFor="password" className="txt-start">
              Confirmar Contraseña *
            </label>
            <divc className="position-relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirmPassword"
                name="confirmPassword"
                className={`form-input ${error.confirmPassword ? "input-error" : ""}`}
                value={form.confirmPassword}
                onChange={handleChange}
              />
              <span
                className="eyes-icon"
                style={{ cursor: "pointer" }}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                <TfiEye size={29} style={{ color: "C1C1C1" }} />
              </span>
            </divc>
            {error.confirmPassword && <p className="error-text">{error.confirmPassword}</p>}
          </div>
          {/* <div className="form-grupo">
          <label htmlFor="document-type">Tipo de Documento *</label>
          <select
          id="documentType"
          name="documentType"
          className={`form-input color-454545 font07rem ${error.documentType ? "input-error" : ""}`}
          value={form.documentType}
          onChange={handleChange}
          >
          <option value="">Seleccione..</option>
          <option value="dni">Dni</option>
          <option value="pasaporte">Pasaporte</option>
          </select>
          {error.documentType && <p className="error-text">{error.documentType}</p>}
          </div> */}
          {/* <div className="form-grupo mrg-r-50">
          <label htmlFor="document">N° de Documento *</label>
          <input
          type="text"
          id="documentNumber"
          name="documentNumber"
          className={`form-input input-documento ${error.documentNumber ? "input-error" : ""}`}
          placeholder="Ingresa tu N° de Documento"
          value={form.documentNumber}
          onChange={handleChange}
          />
          {error.documentNumber && <p className="error-text">{error.documentNumber}</p>}
          </div> */}
          {/* <div className="form-grupo">
          <label htmlFor="phone">Teléfono *</label>
          <div className="phone-input-container">
          <PhoneInput
          country={"pe"}
          onlyCountries={["pe"]}
          value={form.phone}
          onChange={handlePhoneChange}
          containerClass={error.phone ? "input-error" : ""}
          inputProps={{
            name: "phone",
            required: true,
            autoFocus: true,
            className: "form-input form-input-contactanos",
            }}
            />
          </div>
          {error.phone && <p className="error-text">{error.phone}</p>}
          </div> */}
        </div>

        <div className="registrarse-button" onClick={handleCrearCuenta}>
          Crear cuenta
        </div>
        <p className="registro-link color757575">
          ¿Ya tienes una cuenta? <Link to="/iniciar-sesion" className="color757575"> Inicie sesión aquí </Link>
        </p>
      </form>
    </div>
  );
};
